import { defineComponent } from 'vue-demi';
import { s as script$1 } from './OrIcon-22d7aeff.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createVNode, createCommentVNode } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';

var script = defineComponent({
  name: 'OrChip',
  components: {
    OrIcon: script$1
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    isDisabled: Boolean
  },
  emits: ['delete'],
  computed: {
    states() {
      return {
        [this.color]: !!this.color,
        disabled: this.isDisabled
      };
    }
  },
  methods: {
    handleDeleteClick() {
      if (!this.isDisabled) {
        this.$emit('delete');
      }
    }
  }
});

const _hoisted_1 = {
  class: "or-chip-content"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("span", {
    class: normalizeClass(["or-chip", _ctx.states])
  }, [createElementVNode("span", _hoisted_1, toDisplayString(_ctx.content), 1 /* TEXT */), _ctx.canDelete ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "or-chip-button",
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleDeleteClick && _ctx.handleDeleteClick(...args))
  }, [createVNode(_component_or_icon, {
    icon: "close"
  })])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-51cdf14c {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-51cdf14c {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-chip[data-v-51cdf14c] {\n  display: inline-flex;\n  align-items: center;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  overflow: hidden;\n  font-size: var(--fs-0);\n  line-height: var(--lh-0);\n  background-color: var(--c-neutral-2);\n  border-radius: 1rem;\n}\n.or-chip.error[data-v-51cdf14c] {\n  color: var(--c-white);\n  background-color: var(--c-error);\n}\n.or-chip.disabled[data-v-51cdf14c] {\n  opacity: 0.75;\n}\n.or-chip.disabled .or-chip-button[data-v-51cdf14c] {\n  cursor: inherit;\n}\n.or-chip-content[data-v-51cdf14c] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.or-chip-button[data-v-51cdf14c] {\n  display: flex;\n  margin-left: 0.5rem;\n  cursor: pointer;\n  user-select: none;\n}\n.or-chip[data-v-51cdf14c] .or-icon {\n  font-size: 0.875rem;\n  transition: none;\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-51cdf14c";
script.__file = "src/components/or-chips/or-chip/OrChip.vue";

export { script as s };
